var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import { isUndefined } from "engage-common/utils";
//Simplified version of https://github.com/mui-org/material-ui/blob/next/packages/material-ui/src/useMediaQuery/useMediaQuery.js
//Doesn't support SSR for now.
export default function useMediaQuery(queryInput, options) {
    if (options === void 0) { options = {}; }
    var query = queryInput.replace(/^@media( ?)/m, "");
    var _a = __assign({}, options), _b = _a.defaultMatches, defaultMatches = _b === void 0 ? false : _b, _c = _a.matchMedia, matchMedia = _c === void 0 ? window === null || window === void 0 ? void 0 : window.matchMedia : _c;
    var _d = React.useState(function () {
        if (!isUndefined(matchMedia)) {
            return matchMedia(query).matches;
        }
        // Once the component is mounted, we rely on the
        // event listeners to return the correct matches value.
        return defaultMatches;
    }), match = _d[0], setMatch = _d[1];
    React.useEffect(function () {
        var active = true;
        if (isUndefined(matchMedia)) {
            return undefined;
        }
        var queryList = matchMedia(query);
        var updateMatch = function () {
            // Workaround Safari wrong implementation of matchMedia
            // https://github.com/mui-org/material-ui/pull/17315#issuecomment-528286677
            if (active) {
                setMatch(queryList.matches);
            }
        };
        updateMatch();
        //Safari doesn't have addEventListener yet...
        queryList.addListener(updateMatch);
        return function () {
            active = false;
            queryList.removeListener(updateMatch);
        };
    }, [query, matchMedia]);
    return match;
}
//# sourceMappingURL=useMediaQuery.js.map